import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import estimateProvider from "@/providers/estimate.provider";

interface ApplyTPARulesParams {
  estimateId: string;
  tpaId: string;
  carrierId: string;
  approved: boolean;
}

export function useApplyTPARulesMutation() {
  return useMutation({
    mutationFn: async (params: ApplyTPARulesParams) => {
      const response = await estimateProvider.applyTPARules(params);

      if (!response.success) {
        throw new Error("Error applying TPA rules");
      }

      return response;
    },
    onError: () => {
      toast.error("Error applying TPA rules");
    },
    // Cache reconciliation is intentionally left to `useTPARules`: when the rules recompute is queued on
    // the worker, the new TPA/carrier and line items only land once that job finishes, so invalidating
    // here would refetch pre-change server state and clobber the optimistic values mid-recompute.
  });
}
